/**
 * @ipc/validation · src/enums/multicard.ts — сырые enum'ы Multicard (раздел 13,
 * "enums/", дословно из канона). Живут ТОЛЬКО как транспортные enum'ы для
 * разбора ответов SDK/webhook — не путать с нейтральным `PaymentStatus`
 * ядра (`@ipc/core`), который единственный используется в API/UI/аналитике.
 */
import { z } from 'zod/v4';

/** PaymentStatusEnum Multicard (сырой, lowercase). Конечные: success, error, revert. */
export const paymentStatusEnum = z.enum([
  'draft', 'progress', 'billing', 'hold', 'success', 'error', 'revert',
]);
export type MulticardRawStatus = z.infer<typeof paymentStatusEnum>;

/** PaymentServiceEnum Multicard (провайдер средства платежа). */
export const paymentServiceEnum = z.enum([
  'uzcard', 'humo', 'visa', 'mastercard', 'account', 'payme', 'click',
  'uzum', 'anorbank', 'oson', 'alif', 'xazna', 'beepul', 'trastpay', 'sbp',
]);
export type PaymentService = z.infer<typeof paymentServiceEnum>;

/** Коды ошибок Multicard (Rakhmat api/14-errors + docs.multicard.uz/errors). */
export const multicardErrorCodeEnum = z.enum([
  'ERROR_FIELDS',
  'ERROR_TRANS_NOT_READY',
  'ERROR_NOT_FOUND',
  'ERROR_CARD_NOT_FOUND',
  'ERROR_WRONG_OTP',
  'ERROR_DEBIT_UNKNOWN',
  'ERROR_CALLBACK_TIMEOUT',
  'ERROR_UNKNOWN',
  'ERROR_PAYMENT_APPLIED',
  'ERROR_ACCESS_DENIED',
]);
export type MulticardErrorCode = z.infer<typeof multicardErrorCodeEnum>;
